import React from 'react';
import { Loader2, Clock, AlertTriangle, CheckCircle2, Check, CircleDot } from 'lucide-react';

export const PKG_STEPS = [['brand', 'Reading their website'], ['analysis', 'Finding revenue leaks'],
  ['design', 'Building the AI demo agent'], ['proposal', 'Writing the proposal']];

export const pkgActive = (l) => ['queued', 'running'].includes(l?.package_status);

const BADGES = {
  queued: ['Queued', Clock, 'text-amber-300 border-amber-400/30 bg-amber-400/10'],
  running: ['Analyzing', Loader2, 'text-violet-300 border-violet-400/30 bg-violet-400/10'],
  failed: ['Failed', AlertTriangle, 'text-red-300 border-red-400/30 bg-red-400/10'],
  ready: ['Proposal ready', CheckCircle2, 'text-emerald-300 border-emerald-400/30 bg-emerald-400/10'],
};

export const PackageBadge = ({ lead }) => {
  const b = BADGES[lead?.package_status];
  if (!b) return null;
  const [label, Icon, cls] = b;
  return <span className={`inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-full border font-semibold whitespace-nowrap ${cls}`}
    title={lead.package_error || label} data-testid={`lead-pkg-badge-${lead.lead_id}`}>
    <Icon size={10} className={lead.package_status === 'running' ? 'animate-spin' : ''} />{label}
  </span>;
};

export const PackageProgress = ({ lead, dark }) => {
  const queued = lead.package_status === 'queued';
  const current = PKG_STEPS.findIndex(([k]) => k === lead.package_stage);
  const muted = dark ? 'text-white/45' : 'text-slate-500';
  return <div className={`rounded-2xl border p-5 ${dark ? 'border-violet-400/30 bg-violet-400/[0.06]' : 'border-violet-200 bg-violet-50'}`} data-testid="lead-drawer-processing">
    <div className="flex items-center gap-3">
      <span className="w-10 h-10 rounded-xl bg-violet-500/15 text-violet-400 flex items-center justify-center">
        {queued ? <Clock size={18} /> : <Loader2 size={18} className="animate-spin" />}
      </span>
      <div>
        <p className={`text-sm font-bold ${dark ? 'text-white' : 'text-slate-900'}`}>{queued ? 'Queued for Deep Analysis' : 'Deep Analysis in progress'}</p>
        <p className={`text-xs ${muted}`}>{queued ? 'Starts automatically when earlier analyses finish.' : 'Usually 2–4 minutes. You can close this and keep working.'}</p>
      </div>
    </div>
    <div className="mt-4 space-y-2.5">
      {PKG_STEPS.map(([k, label], i) => {
        const done = !queued && current > i;
        const now = !queued && (current === i || (current < 0 && i === 0));
        return <div key={k} className="flex items-center gap-2.5 text-xs" data-testid={`lead-pkg-step-${k}`}>
          {done ? <Check size={14} className="text-emerald-400" /> : now ? <Loader2 size={14} className="animate-spin text-violet-400" /> : <CircleDot size={14} className={`${muted} opacity-50`} />}
          <span className={done || now ? (dark ? 'text-white' : 'text-slate-800') : muted}>{label}</span>
        </div>;
      })}
    </div>
  </div>;
};
